import { render, staticRenderFns } from "./RecipientListItem.vue?vue&type=template&id=570b2a36"
import script from "./RecipientListItem.vue?vue&type=script&lang=js"
export * from "./RecipientListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports